export default "__VITE_ASSET__B2iJR1$o__"